/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * Login Messages
 *
 * This contains all the text for the Login component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    copyright: {
        id: 'copyright',
        defaultMessage: 'Copyright \u00a9 2015-{currentYear} Lifesize, Inc. All rights reserved.'
    },
    legal: {
        id: 'login.legal',
        defaultMessage: 'By accessing the Service, you agree to the following terms: '
    },
    legalLinkLabel: {
        id:'login.legalLinkLabel',
        defaultMessage: 'Link'
    },
    privacyPolicy: {
        id: 'login.privacyPolicy',
        defaultMessage: 'Privacy Policy'
    }
})